/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHomePageBannerViewProps } from './home-page-banner';

export default (props: IHomePageBannerViewProps) => {
    return (
        <div className='Footer-IconsCMS'>
            <div className='CmsBlock-Wrapper CmsBlock-Wrapper_type_'>
                {props.config.banners?.map((banner, index) => {
                    return (
                        <div key={index} id='customise-icon' className='Column'>
                            <div className='Icon'>
                                <a title={banner.title} href={banner.link} className=' '>
                                    <img src={banner.icon?.src} alt={banner.icon?.altText} width='55' height='48' />
                                </a>
                            </div>
                            <div className='Content'>
                                <div className='Title'>
                                    <span style={{ color: 'rgb(255, 255, 255)' }}>
                                        <a title={banner.title} href={banner.link} className=' ' style={{ color: 'rgb(255, 255, 255)' }}>
                                            {banner.title}
                                        </a>
                                    </span>
                                </div>
                                <div className='Text'>
                                    <span style={{ color: 'rgb(255, 255, 255)' }}>
                                        <a title={banner.title} href={banner.link} className=' ' style={{ color: 'rgb(255, 255, 255)' }}>
                                            <span style={{ color: 'rgb(255, 255, 255)' }}>{banner.description}</span>
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
